/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantUnitOvertimeRulesetRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {GetMerchantUnitOvertimeRulesetResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const getMerchantUnitOvertimeRuleset = (request: GetMerchantUnitOvertimeRulesetRequest, options?: CashRequestOptions) => post<GetMerchantUnitOvertimeRulesetRequest, GetMerchantUnitOvertimeRulesetResponse>("/proxy/services/squareup.timecards.TimeCalculationService/GetMerchantUnitOvertimeRuleset", request, {...options, rejectOnError: true })